/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
import type { Configuration, IPublicClientApplication } from "@azure/msal-browser";
import { PublicClientNext, createNestablePublicClientApplication } from "@azure/msal-browser";

// Enter here the user flows and custom policies for your B2C application
// To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
// To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "b2543857-bb17-400a-812b-39300e13fe16",
    authority: import.meta.env.VITE_AZURE_AUTHORITY || "https://login.microsoftonline.com/common",
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || "/", // Must be registered as a SPA redirectURI on your app registration
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_POST_LOGOUT_REDIRECT_URI || "/" // Must be registered as a SPA redirectURI on your app registration
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // switch (level) {
        //   case 0: // LogLevel.Error
        //     console.error(message);
        //     return;
        //   case 1: // LogLevel.Warning
        //     console.warn(message);
        //     return;
        //   case 2: // LogLevel.Info
        //     console.info(message);
        //     return;
        //   case 3: // LogLevel.Verbose
        //     console.debug(message);
        //     return;
        // }
      }
    }
  }
};

export const msalInstance = await PublicClientNext.createPublicClientApplication(msalConfig);

let msalNaaInstance: IPublicClientApplication | null = null;

export async function getMsalNaaInstance(): Promise<IPublicClientApplication | null> {
  if (msalNaaInstance) return msalNaaInstance;
  try {
    msalNaaInstance = await createNestablePublicClientApplication({
      auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "646b20dc-fdf8-4991-ac63-135f8c7db29c",
        authority:
          import.meta.env.VITE_AZURE_AUTHORITY || "https://login.microsoftonline.com/common",
        redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || "/",
        postLogoutRedirectUri: import.meta.env.VITE_AZURE_POST_LOGOUT_REDIRECT_URI || "/"
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return;
            }
          }
        }
      }
    });
    return msalNaaInstance;
  } catch (error) {
    console.warn("MSAL NAA not supported in this environment:", error);
    return null;
  }
}

export const opScopes = {
  scopes: [import.meta.env.VITE_SCOPE_GRAPH_USER_READ]
};

export const graphScopes = {
  scopes: [".default"]
};
